var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"icon-line--style","stroke":"currentcolor","fill":"none","strokeWidth":"2.3","d":"M1.153 6.847l5.843-5.69 5.863 5.696","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Chevron.defaultProps = {"width":"14","height":"8"};

module.exports = Chevron;

Chevron.default = Chevron;
